import { render, staticRenderFns } from "./PAReports.vue?vue&type=template&id=138465a8&"
import script from "./PAReports.vue?vue&type=script&lang=js&"
export * from "./PAReports.vue?vue&type=script&lang=js&"
import style0 from "./PAReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAReports.vue"
export default component.exports